import {Component} from '@angular/core';

@Component({
  selector: 'queue-ico',
  templateUrl: './queue-ico.component.html'
})
export class QueueIcoComponent {
}
